import TablesSocketConnectionManager from './TablesSocketConnectionManager';
import connectContainer from './TablesSocketConnectionManagerContainer';

export default connectContainer(TablesSocketConnectionManager);
